import SmartButton from "../../buttons/SmartButton";

function TablaValidateLicenseRow({ item, onDecision }) {
  const p = item.provider || {};
  const a = p.address || {};

  return (
    <tr>
      <td>
        {a.address_line_one
          ? `${a.address_line_one}${
              a.address_line_two ? ", " + a.address_line_two : ""
            }${a.address_apt ? ", Apt " + a.address_apt : ""}, ${
              a.address_city
            }, ${a.address_state} ${a.address_zip}`
          : "-"}
      </td>
      <td>{p.first_name || ""}</td>
      <td>{p.last_name || ""}</td>
      <td>{p.email || ""}</td>
      <td>{p.phone || ""}</td>
      <td>{item.license || ""}</td>
      <td>
        <div style={{ display: "flex", gap: "12px" }}>
          <SmartButton
            text="Accept"
            icon="check_circle"
            onClick={() => onDecision(p, "Approved", item.license)}
            className="btnAccept"
          />
          <SmartButton
            text="Reject"
            icon="close"
            onClick={() => onDecision(p, "Rejected", item.license)}
            className="btnReject"
          />
        </div>
      </td>
    </tr>
  );
}

export default TablaValidateLicenseRow;
